<template style="font-family: 'Montserrat', sans-serif;">
  <div id="app" style="background-color: white"
       :class="[{'collapsed' : collapsed}]">

    <div id="app1" class="container1">
      <div v-if="!isPopup" class="container-fluid" style="width: 100%; padding-left: 0;">
        <div>
          <b-row align-v="center">

            <b-col sm="2">
              <div style="display: inline"><a href="https://napagreen.org" target="_blank"
                                              rel="noopener noreferrer"><img
                  src="./assets/napa_green_block.jpg"
                  style="width: 300px; padding: 20px" alt="Napa Green Logo"></a>
              </div>
            </b-col>
            <b-col>
              <div class="user-navigation"
                   style="float: right; text-align: right; vertical-align: center; padding-left: 10px;">
                               <span class="align-bottom" style="padding-bottom: 20px;">
                                   <a target="_blank" href="https://napagreen.org"
                                      style="padding-left: 10px; padding-right: 15px; font-family: 'Lato', sans-serif; font-size: 16px; color: green; "
                                      rel="noopener noreferrer">NapaGreen.org</a>
                                <a class="no-ajax" href="https://napagreen.org/participating-members"
                                   style="padding-left: 10px; font-family: 'Lato', sans-serif; font-size: 16px;color: green"
                                   target="_blank" rel="noopener noreferrer">Certified Members</a>
                                <button class="help-nav-btn" @click="openHelp" title="Help">
                                  <font-awesome-icon icon="question-circle" />
                                </button></span>
              </div>
            </b-col>
            <b-col sm="1">
              <div style="float: right">
                <div v-show="isNapaProperty" style="display: inline-block;margin-right: 3px"><a
                    href="https://napagreen.org" target="_blank"
                                                                        rel="noopener noreferrer">
                <img :src="iconToDisplay" alt="NapaGreen Winery"
                     style="height: 75px; float: right; clear: right; color: lightgreen">
              </a>
              </div>
                <div v-show="!isNapaProperty" style="display: inline-block">
                  <a href="https://napagreen.org" target="_blank" rel="noopener noreferrer">
                  <img :src="iconToDisplayClimate" alt="NapaGreen Climate"
                     style="height: 75px; float: right; clear: right; color: lightgreen">
              </a>
              </div>
              </div>
            </b-col>
          </b-row>
        </div>
        <b-row>
          <b-col sm="12" style="padding-right: 0">
            <vue-navigation-bar :options="navbarOptions" @vnb-item-clicked="vnbItemClicked"
                                style="background-color: #f2f2f2; padding: 2px 0 2px 2px;"
                                v-if="this.$router.currentRoute.path !== '/request-land-certification'
                                    && this.$router.currentRoute.path !== '/request-account-from-me'
                                    && this.$router.currentRoute.path !== '/request-vineyard-account'">
            </vue-navigation-bar>
          </b-col>
        </b-row>

      </div>
      <router-view/>
      <b-container v-if="displayAdminMenu && !isPopup" style="width: 10px">
        <sidebar-menu

            :menu="sidebarMenu"
            :collapsed="collapsed"
            :theme="selectedTheme"
            :show-one-child="true"
            @collapse="onCollapse"
            @item-click="onItemClick"
        />
      </b-container>
      <HelpPanel v-if="!isPopup" />
    </div>
  </div>
</template>

<script>
import "vue-sidebar-menu/src/scss/vue-sidebar-menu.scss";
import 'vue-navigation-bar/dist/vue-navigation-bar.css'
import VueNavigationBar from 'vue-navigation-bar'
import Bus from "./eventBus";
import {globalStore} from "./main";
import Vue from 'vue';
import VuejsDialog from 'vuejs-dialog'
// include the default style
import 'vuejs-dialog/dist/vuejs-dialog.min.css';
import Swal from "sweetalert2";
import {
  isAdmin,
  isAdminClass,
  isAdminOrCertifier,
  isAdminVineyardAdminOrCertifier,
  isCertifier,
  isNonCertifierAdmin,
  isPureAdmin,
  isVineyardAdmin,
  isVineyardAdminMeth
} from "@/lib/UserUtils";
import {FileUtils} from "@/lib/FileUtils";
import HelpPanel from '@/components/help/HelpPanel';


Vue.use(VuejsDialog);

const separator = {
  template: `<hr style="border-color: rgba(0, 0, 0, 0.1); margin: 20px;">`
};


Storage.prototype.setObject = function (key, value) {
  this.setItem(key, JSON.stringify(value));
}

Storage.prototype.getObject = function (key) {
  let value = this.getItem(key);
  return value && JSON.parse(value);
}

export default {
  components: {
    VueNavigationBar,
    HelpPanel
  },
  name: 'app',
  data() {
    return {
      groupName: '',
      entityType: localStorage.getItem('entityType') !== null ? localStorage.getItem('entityType') : 'WINE',//'WINE',
      isAdmin: isAdmin(),
      isCertifier: isCertifier(),
      isVineyardAdmin: isVineyardAdmin(),
      theGroup: localStorage.getItem('groupName') !== null ? localStorage.getItem("groupName") : ' ',
      menu: [],
      collapsed: false,
      themes: ['', 'white-theme'],
      selectedTheme: 'default-theme',
      surveys: null,
      navbarOptions: {
        elementId: "main-navbar",
        isUsingVueRouter: true,
        mobileBreakpoint: 940,
        brandImagePath: "./",

        brandImageAltText: "brand-image",
        collapseButtonOpenColor: "darkgreen",
        collapseButtonCloseColor: "darkfreen",
        showBrandImageInMobilePopup: false,
        ariaLabelMainNav: "Main Navigation",
        tooltipAnimationType: "shift-away",
        menuOptionsLeft: [
          {
            type: "link",
            text: "Home Page",
            path: "my-account"
          },
          {
            type: "link",
            text: "Account",
            subMenuOptions: [
              {
                type: "link",
                text: "My Team",
                subText: "View/Add team members.",
                path: "Groups"
              },
              {
                type: "hr"
              },
              {
                type: "link",
                text: "Update Account",
                subText: "Update my account.",
                path: "user-info"
              },
              {
                type: "hr"
              },
              {
                type: "link",
                text: "My Organization",
                subText: "Update my Organization.",
                path: "update-account-info"
              },
              {
                type: "hr"
              },
              {
                type: "link",
                text: "Update Password",
                path: "update-password"
              },
              {
                type: "hr"
              },
              {
                isLinkAction: true,
                type: "link",
                text: "Switch Operation",
                path: "group-selector"
              }
            ]
          },
          {
            /*isLinkAction: true,*/
            type: "link",
            text: "Action Items",
            subMenuOptions: [
              {
                isLinkAction: true,
                type: "link",
                text: "Standards",
                path: "/survey"
              },
              {
                type: "hr"
              },
              {
                isLinkAction: true,
                type: "link",
                text: "PDFs of Standards",
                path: "/"
              },
              {
                type: "hr"
              },
              {
                isLinkAction: true,
                type: "link",
                text: "Action Plan Spreadsheet",
                path: "action-plan"
              },
              {
                type: "hr"
              },
              {
                isLinkAction: true,
                type: "link",
                text: "Metric Calculator",
                path: "metrics-tabbed"
              },
              {
                type: "hr"
              },
              {
                isLinkAction: true,
                type: "link",
                text: "Annual Update",
                path: "annual-update"
              },
              {
                type: "hr"
              },
              {
                isLinkAction: true,
                type: "link",
                text: "Documentation",
                path: "comments"
              }
            ]
          },
          {
            isLinkAction: true,
            type: "link",
            text: "Resources",
            path: "https://napagreen.org/member-resources"
          },
          {
            isLinkAction: true,
            type: "link",
            text: "Contact Us",
            path: "https://napagreen.org/contact-us"
          },
          {
            isLinkAction: true,
            type: "link",
            text: "Logout",
            path: "https://napagreen.org/logout"
          }
        ],
        menuOptionsRight: [
          {
            isLinkAction: true,
            type: 'link',
            text: this.theGroup,
            path: 'swap-menu'
          }
        ]
      },
      backdoor: 0,
      menuSwap: 0,
      theCounty: localStorage.getObject("county")
    }
  },
  computed: {
    isPopup: function () {
      return !!(this.$route.meta && this.$route.meta.popup);
    },
    county: function () {
      return this.$store.getters["user/currentCounty"];
    },
    displayAdminMenu: function () {
      return this.isAdmin || this.isCertifier || this.isVineyardAdmin;
    },
    sidebarMenu: function () {
      console.log(this.backdoor);
      let sideMenuModel = [];
      sideMenuModel.push(
          {
            header: true,
            component: separator,
            visibleOnCollapse: true
          },
          {
            header: true,
            title: 'Administration'
          },
          {
            href: '/questionnaire-admin',
            title: 'Checklists',
            icon: 'fa fa-list-ul',
          });
      if (isNonCertifierAdmin()) {
        sideMenuModel.push(
            {
              href: '/administration',
              title: 'Administration',
              icon: 'fa fa-tools'
            });
      }
      let isPureAdminOrVineyardAdmin = isPureAdmin() || isVineyardAdminMeth();
      if (isPureAdminOrVineyardAdmin) {
        sideMenuModel.push(
            {
              href: '/review-requests',
              title: 'Review Requests',
              icon: 'fa fa-cog',
            }
        );
      }
      let isAdminOrCertifer = isAdminOrCertifier();
      if (isAdminOrCertifer) {
        sideMenuModel.push(
            {
              header: true,
              component: separator,
              visibleOnCollapse: true
            },
            {
              href: '/compliance',
              title: 'Compliance',
              icon: 'fa fa-gavel',
            });
      }
      let isNonCertifierAdminVal = isNonCertifierAdmin();
      if (isNonCertifierAdminVal) {
        sideMenuModel.push(
            {
              href: '/measures',
              title: 'View Questions',
              icon: 'fa fa-question-circle'
            },
            {
              href: '/create-question',
              title: 'Create Question',
              icon: 'fa fa-pen-square'
            },
            {
              href: '/login-admin',
              title: 'Login Auditing',
              icon: 'fa fa-sign-in-alt'
            },
            {
              href: '/users',
              title: 'User List',
              icon: 'fa fa-users'
            },
            {
              href: '/external-resources',
              title: 'Resource Links',
              icon: 'fa fa-link'
            },
            {
              href: '/edit/notification',
              title: 'Edit Notifications',
              icon: 'fa fa-sticky-note'
            },
            {
              href: '/upcoming-alerts',
              title: 'Upcoming Notifications',
              icon: 'fa fa-mail-bulk'
            },
            {
              href: '/alerts-sent',
              title: 'Sent Alerts',
              icon: 'fa fa-envelope-open'
            },
            {
              href: '/vineyard-editor?checklistType=VINEYARD',
              title: 'Checklist Editor',
              icon: 'fa fa-wine-bottle',
            },
            {
              href: '/create-user',
              title: 'Create User',
              icon: 'fa fa-user-plus'
            },
            {
              href: '/parent-company',
              title: 'View Parent Companies',
              icon: 'fa fa-umbrella'
            },
            {
              href: '/create/parent-company',
              title: 'Create Parent Company',
              icon: 'fa fa-child'
            });
      }
      return sideMenuModel;
    },
    displayWineryMenu: function () {
      return this.entityType === "WINE";
    },
    isNapaProperty: function () {
      return this.$store.getters["user/isNapaProperty"];
    },
    iconToDisplay: function () {
      let ent = '';
      console.log(`Entity Type: ${this.entityType}`)
      if (this.entityType === "WINE") {
        if (this.county === "28" || this.county === 28) {
          ent = 'napa_green_winery-1';
        } else {
          ent = 'beyond-green-winery';
        }
      } else {
        if (this.county === "28" || this.county === 28) {
          ent = 'napa_green_vineyard';
        } else {
          ent = 'beyond-green-vineyard';
        }

      }

      let item = `@/assets/${ent}.jpg`;
      console.log("Icon To Display: ", item)
      return require("@/assets/" + ent + ".jpg");
      //  return item;
    },
    iconToDisplayClimate: function () {
      let ent = '';
      if (this.entityType === "WINE") {
        ent = 'beyond-green-winery';
      } else {
        ent = 'beyond-green-vineyard';
      }

      let item2 = `@/assets/${ent}.jpg`;
      console.log("Climate Icon To Display: ", item2)
      return require("@/assets/" + ent + ".jpg");
      //  return item;
    },
  },
  created() {
    Bus.$on('show-sidebar', this.isDisplayed);
    Bus.$on('group-update', this.updateGroupName);
    Bus.$on('update-entityType', this.updateEntityType);

  },
  beforeDestroy() {
    Bus.$off('show-sidebar', this.isDisplayed);
    Bus.$off('group-update', this.updateGroupName);
    Bus.$off('update-entityType', this.updateEntityType);
  },
  mounted() {
    this.backdoor++;
    this.$set(this.navbarOptions.menuOptionsRight, 0, {
          isLinkAction: true,
          type: 'link',
          text: this.theGroup,
          path: './customer-service'
        },
    );
    this.$set(this.navbarOptions.menuOptionsRight, 1,
        {
          isLinkAction: true,
          type: 'link',
          text: `v.${this.$appVerion}`,
          path: 'swap-menu'
        });
  },
  methods: {
    openHelp() {
      this.$store.dispatch('help/openPanel', this.$route.path.replace(/^\//, ''));
    },
    switchMenu: function () {
      if (this.menuSwap === 0) {
        this.navbarOptions = {
          elementId: "main-navbar",
          isUsingVueRouter: true,
          mobileBreakpoint: 940,
          brandImagePath: "./",

          brandImageAltText: "brand-image",
          collapseButtonOpenColor: "darkgreen",
          collapseButtonCloseColor: "darkfreen",
          showBrandImageInMobilePopup: false,
          ariaLabelMainNav: "Main Navigation",
          tooltipAnimationType: "shift-away",
          menuOptionsLeft: [
            {
              type: "link",
              text: "New Home Page",
              path: "my-account"
            },
            {
              type: "link",
              text: "Account",
              subMenuOptions: [
                {
                  type: "link",
                  text: "My Team",
                  subText: "View/Add team members.",
                  path: "Groups"
                },
                {
                  type: "hr"
                },
                {
                  type: "link",
                  text: "Update Account",
                  subText: "Update my account.",
                  path: "user-info"
                },
                {
                  type: "hr"
                },
                {
                  type: "link",
                  text: "My Organization",
                  subText: "Update my Organization.",
                  path: "update-account-info"
                },
                {
                  type: "hr"
                },
                {
                  type: "link",
                  text: "Update Password",
                  path: "update-password"
                },
                {
                  type: "hr"
                },
                {
                  isLinkAction: true,
                  type: "link",
                  text: "Switch Organization",
                  path: "group-selector"
                }
              ]
            },
            {
              /*isLinkAction: true,*/
              type: "link",
              text: "Action Items",
              subMenuOptions: [
                {
                  isLinkAction: true,
                  type: "link",
                  text: "Standards",
                  path: "/survey"
                },
                {
                  type: "hr"
                },
                {
                  isLinkAction: true,
                  type: "link",
                  text: "PDFs of Standards",
                  path: "/"
                },
                {
                  type: "hr"
                },
                {
                  isLinkAction: true,
                  type: "link",
                  text: "Action Plan Spreadsheet",
                  path: "action-plan"
                },
                {
                  type: "hr"
                },
                {
                  isLinkAction: true,
                  type: "link",
                  text: "Metric Calculator",
                  path: "metrics-tabbed"
                },
                {
                  type: "hr"
                },
                {
                  isLinkAction: true,
                  type: "link",
                  text: "Annual Update",
                  path: "annual-update"
                },
                {
                  type: "hr"
                },
                {
                  isLinkAction: true,
                  type: "link",
                  text: "Documentation",
                  path: "comments"
                }
              ]
            },
            {
              isLinkAction: true,
              type: "link",
              text: "Resources",
              path: "https://napagreen.org/member-resources"
            },
            {
              isLinkAction: true,
              type: "link",
              text: "Contact Us",
              path: "https://napagreen.org/contact-us"
            },
            {
              isLinkAction: true,
              type: "link",
              text: "Logout",
              path: "https://napagreen.org/logout"
            }
          ],
          menuOptionsRight: [
            {
              isLinkAction: true,
              type: 'link',
              text: this.theGroup,
              path: './customer-service'
            }
          ]
        };
        this.menuSwap = 1;
      } else {
        this.navbarOptions = {
          elementId: "main-navbar",
          isUsingVueRouter: true,
          mobileBreakpoint: 940,
          brandImagePath: "./",

          brandImageAltText: "brand-image",
          collapseButtonOpenColor: "darkgreen",
          collapseButtonCloseColor: "darkgreen",
          showBrandImageInMobilePopup: false,
          ariaLabelMainNav: "Main Navigation",
          tooltipAnimationType: "shift-away",
          menuOptionsLeft: [
            {
              type: "link",
              text: "Home Page",
              path: "my-account"
            },
            {
              type: "link",
              text: "Account",
              subMenuOptions: [
                {
                  type: "link",
                  text: "My Team",
                  subText: "View/Add team members.",
                  path: "Groups"
                },
                {
                  type: "hr"
                },
                {
                  type: "link",
                  text: "Update Account",
                  subText: "Update my account.",
                  path: "user-info"
                },
                {
                  type: "hr"
                },
                {
                  type: "link",
                  text: "My Organization",
                  subText: "Update my Organization.",
                  path: "update-account-info"
                },
                {
                  type: "hr"
                },
                {
                  type: "link",
                  text: "Update Password",
                  path: "update-password"
                },
                {
                  type: "hr"
                },
                {
                  type: "hr"
                },
                {
                  isLinkAction: true,
                  type: "link",
                  text: "Switch Organization",
                  path: "group-selector"
                }
              ]
            },
            {
              /*isLinkAction: true,*/
              type: "link",
              text: "Action Items",
              subMenuOptions: [
                {
                  isLinkAction: true,
                  type: "link",
                  text: "Standards",
                  path: "/survey"
                },
                {
                  type: "hr"
                },
                {
                  isLinkAction: true,
                  type: "link",
                  text: "PDFs of Standards",
                  path: "/"
                },
                {
                  type: "hr"
                },
                {
                  isLinkAction: true,
                  type: "link",
                  text: "Action Plan Spreadsheet",
                  path: "action-plan"
                },
                {
                  type: "hr"
                },
                {
                  isLinkAction: true,
                  type: "link",
                  text: "Metric Calculator",
                  path: "metrics-tabbed"
                },
                {
                  type: "hr"
                },
                {
                  isLinkAction: true,
                  type: "link",
                  text: "Annual Update",
                  path: "annual-update"
                },
                {
                  type: "hr"
                },
                {
                  isLinkAction: true,
                  type: "link",
                  text: "Documentation",
                  path: "comments"
                }
              ]
            },
            {
              isLinkAction: true,
              type: "link",
              text: "Resources",
              path: "https://napagreen.org/member-resources"
            },
            {
              isLinkAction: true,
              type: "link",
              text: "Contact Us",
              path: "https://napagreen.org/contact-us"
            },
            {
              isLinkAction: true,
              type: "link",
              text: "Logout",
              path: "https://napagreen.org/logout"
            }
          ],
          menuOptionsRight: [
            {
              isLinkAction: true,
              type: 'link',
              text: this.theGroup,
              path: './customer-service'
            }
          ]
        };
        this.menuSwap = 0;
      }
    },
    scrollFix: function (hashbang) {
      location.href = hashbang;
    },
    isDisplayed: function (value) {
      this.menu = [];
      globalStore.isAdmin = value;
      this.isAdmin = globalStore.isAdmin;
      this.backdoor++;
    },
    updateGroupName: function (value) {
      /*
         TODO add welcome message here i.e.  "Welcome 'Whoever' of 'Such and Such Vineyard'"
       */
      this.groupName = value;
      this.theGroup = value;
      console.log("The Group Name updated to: " + this.theGroup);
      localStorage.setItem("groupName", value);
      this.$store.commit('user/groupName', value);
      this.$set(this.navbarOptions.menuOptionsRight, 0, {
        isLinkAction: true,
        type: 'link',
        text: this.theGroup,
        path: './customer-service'
      });
    },
    updateEntityType: function (value) {
      this.entityType = value;
      if (this.entityType === "VINEYARD") {
        this.$set(this.navbarOptions.menuOptionsLeft, 2, {
          /*isLinkAction: true,*/
          type: "link",
          text: "Action Items",
          subMenuOptions: [
            {
              isLinkAction: true,
              type: "link",
              text: "Standards",
              path: "/survey"
            },
            {
              type: "hr"
            },
            {
              isLinkAction: true,
              type: "link",
              text: "PDFs of Standards",
              path: "/"
            },
            {
              type: "hr"
            },
            {
              isLinkAction: true,
              type: "link",
              text: "Metric Calculator",
              path: "metrics-tabbed"
            },
            {
              type: "hr"
            },
            {
              isLinkAction: true,
              type: "link",
              text: "Annual Update",
              path: "annual-update"
            },
            {
              type: "hr"
            },
            {
              isLinkAction: true,
              type: "link",
              text: "Documentation",
              path: "comments"
            }
          ]
        });
      } else if (this.entityType === "WINE") {
        this.$set(this.navbarOptions.menuOptionsLeft, 2, {
          /*isLinkAction: true,*/
          type: "link",
          text: "Action Items",
          subMenuOptions: [
            {
              isLinkAction: true,
              type: "link",
              text: "Standards",
              path: "/survey"
            },
            {
              type: "hr"
            },
            {
              isLinkAction: true,
              type: "link",
              text: "PDFs of Standards",
              path: "/"
            },
            {
              type: "hr"
            },
            {
              isLinkAction: true,
              type: "link",
              text: "Action Plan Spreadsheet",
              path: "action-plan"
            },
            {
              type: "hr"
            },
            {
              isLinkAction: true,
              type: "link",
              text: "Metric Calculator",
              path: "metrics-tabbed"
            },
            {
              type: "hr"
            },
            {
              isLinkAction: true,
              type: "link",
              text: "Annual Update",
              path: "annual-update"
            },
            {
              type: "hr"
            },
            {
              isLinkAction: true,
              type: "link",
              text: "Documentation",
              path: "comments"
            }
          ]
        });
      }
    },
    onCollapse(collapsed) {
      this.collapsed = collapsed
    },
    onItemClick(event, item) {
      //console.log('Event: [' + event + '] Item Name: [' + item.name + ' ]')
    },
    logout: function () {
      localStorage.removeItem("user");
      localStorage.clear();
      this.groupName = '';
      this.theGroup = ''
      this.isAdmin = false;
      this.isVineyardAdmin = false;
      this.$set(this.navbarOptions.menuOptionsRight, 0, {
        isLinkAction: true,
        type: 'link',
        text: this.theGroup,
        path: './customer-service'
      });
      this.$router.push("/login");
    },
    handleError: function (err) {
      console.log(err.message);
    },
    getChecklistRouterPathName: function(){
      return "Vineyard Page";
    },
    showSelectASurveyPopUp: function () {
      Swal.fire({
        title: 'Select A Survey',
        text: 'Please Select a Organization to Continue.',
        icon: 'question'
      });
    },
    vnbItemClicked(text) {
      if (text === "Resources") {
        window.open("https://napagreen.org/member-resources", "_blank");
      }
      if (text === "Contact Us") {
        window.open("https://napagreen.org/contact-us", "_blank");
      }
      if (text === "Logout") {
        this.logout();
      }
      if (text === "Documentation") {
        let isUserAdminClass = isAdminClass();
        let groupId = isUserAdminClass ? localStorage.getItem('adminImpersonationGroupId') : localStorage.getItem('groupId');
        if (isUserAdminClass) {
          if (groupId == null) {
            this.showSelectASurveyPopUp()
          }
        }

        let docsUpdateRouteName = "Comments";
        this.$router.push({
          name: docsUpdateRouteName
        })
            .catch(err => {
              this.handleError(err);
            });
      }
      if (text === "Standards") {
        let groupId;
        if (isAdminVineyardAdminOrCertifier()) {
          this.showSelectASurveyPopUp()
          this.$router.push({name: "Questionnaire Admin"})
              .catch(err => {
                this.this.handleError(err);
              });
          return;
        } else {
          groupId = localStorage.getItem('groupId')
        }

        let routerPathName = this.getChecklistRouterPathName();
        this.$router.push({
          name: routerPathName,
          params: {
            surveyKey: localStorage.getItem('surveyKey'),
            groupId: localStorage.getItem('groupId')
          }
        })
            .catch(err => {
              this.handleError(err);
            });

      }
      if (text === "PDFs of Standards") {
        let groupId;
        //let isAdminOrCertifier = isAdminOrCertifier();
        if (isAdminOrCertifier()) {
          groupId = localStorage.getItem('adminImpersonationGroupId');
          if (groupId == null) {
            Swal.fire({
              title: 'Select An Entity',
              text: 'Please Select an Entity to Continue.',
              icon: 'question'
            });
            this.$router.push({name: "Questionnaire Admin"})
                .catch(err => {
                  this.handleError(err);
                });
            return;
          }
        } else {
          groupId = localStorage.getItem('groupId')
        }
        console.log("About to navigate to the PDF generator.")


        ///////////////////////////////////////////////////////
        this.$toasted.show('Standards download has begun...Please wait.',
            {
              containerClass: 'super-toasty',
              iconPack: 'fontawesome',
              closeOnSwipe: true,
              action: {
                text: 'DISMISS',
                onClick: (e, toastObject) => {
                  toastObject.goAway(0);
                }
              },
              icon: {
                name: 'fa-check-circle',
                after: false,
              }
            })
            .goAway(5000);

        ///////////////////////////////////////////////////////


        this.$http.get(`survey/pdf/download/${groupId}`, {responseType: "blob"})
            .then(async response => {
              FileUtils.savePdfToDisk(response);
            });
      }
      if (text === "Action Plan Spreadsheet") {
        console.log("Entity Type: " + this.entityType);
        if (this.entityType !== "WINE") {
          return;
        }
        let groupId;
        if (localStorage.getItem('roles').includes('admin') || localStorage.getItem('roles').includes('THIRD_PARTY_CERTIFIER')
            || localStorage.getItem('roles').includes('VINEYARD_ADMIN')) {
          groupId = localStorage.getItem('adminImpersonationGroupId');
          if (groupId == null) {
            Swal.fire({
              title: 'Select A Survey',
              text: 'Please Select a Winery to Continue.',
              icon: 'question'
            });
            this.$router.push({name: "Questionnaire Admin"})
                .catch(err => {
                  this.handleError(err);
                });
            return;
          }
        } else {
          groupId = localStorage.getItem('groupId')
        }

        ///////////////////////////////////////////////////////
        this.$toasted.show('Action Plan generation has begun...Please wait.',
            {
              containerClass: 'super-toasty',
              iconPack: 'fontawesome',
              closeOnSwipe: true,
              action: {
                text: 'DISMISS',
                onClick: (e, toastObject) => {
                  toastObject.goAway(0);
                }
              },
              icon: {
                name: 'fa-check-circle',
                after: false,
              }
            })
            .goAway(5000);

        ///////////////////////////////////////////////////////

        this.$http.get(`survey/action_plan/${groupId}/generate`, {responseType: "blob"})
            .then(async response => {
              FileUtils.saveExcelToDisk(response);
            });
      }
      if (text === "Switch Operation") {
        if (localStorage.getItem("multiGroupUser") === 'true') {
          this.$router.push({name: "GroupSelector"})
              .catch(err => {
                this.handleError(err);
              });
        }
      }
      if (text === "Metric Calculator") {
        if (localStorage.getItem('roles').includes('admin') || localStorage.getItem('roles').includes('THIRD_PARTY_CERTIFIER')
            || localStorage.getItem('roles').includes('VINEYARD_ADMIN')) {
          this.showSelectASurveyPopUp();
          this.$router.push({name: "Questionnaire Admin"})
              .catch(err => {
                this.handleError(err);
              });
        } else {
          this.$router.push({name: "TabbedMetrics", params: {groupId: localStorage.getItem('groupId')}})
              .catch(err => {
                this.handleError(err);
              });
        }
      }
      if (text === "Annual Update") {
        let isAdminClass = isAdminClass;
        let entityType = isAdminClass ? localStorage.getItem('adminImpersonationEntityType') : localStorage.getItem('entityType')
        let groupId = isAdminClass ? localStorage.getItem('adminImpersonationGroupId') : localStorage.getItem('groupId');
        if (isAdminClass) {
          if (groupId == null) {
            swal("Please Select a winery to continue.");
            this.$router.push({name: "Questionnaire Admin"})
                .catch(err => {
                  this.handleError(err);
                });
            return;
          }
        }

        let docsUpdateRouteName = entityType !== "WINE" ? "Documentation" : "Annual Update";
        this.$router.push({
          name: docsUpdateRouteName
        })
            .catch(err => {
              this.handleError(err);
            });
      }
      if (text === "My Winery") {
        let groupId;
        if (localStorage.getItem('roles').includes('admin') || localStorage.getItem('roles').includes('THIRD_PARTY_CERTIFIER')) {
          this.showSelectASurveyPopUp();
          this.$router.push({name: "Questionnaire Admin"})
              .catch(err => {
                this.handleError(err);
              });
          return;
        } else {
          groupId = localStorage.getItem('groupId')
        }

        this.$router.push({
          name: "Update_Account"
        })
            .catch(err => {
              this.handleError(err);
            });
      }
      if (text.includes("(")){
        //this.switchMenu();
      }
    }
  }
}
</script>
<style lang="scss">
@import 'scss/vue-sidebar-menu.scss';
@import url('https://fonts.googleapis.com/css?family=Source+Sans+Pro:400,600');
@import url('https://fonts.googleapis.com/css?family=Lato:400,700');

.help-nav-btn {
  background: none;
  border: none;
  cursor: pointer;
  color: #4a7c59;
  font-size: 18px;
  padding: 0 0 0 12px;
  vertical-align: middle;
  &:hover { color: #2d5a38; }
}

body,
html {
  margin: 0;
  padding: 0;
}

body {
  font-family: 'Source Sans Pro', sans-serif;
  background-color: #f2f4f7;
}

#app {
  //padding-left: 225px;
}

#app.collapsed {
  padding-left: 50px;
}

.app {
  padding: 50px;
}

.container1 {
  max-width: 100%;
}

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
  color: #2c3e50;
  margin-top: 10px;
}

pre {
  color: #2a2a2e;
  background: #fff;
  border-radius: 2px;
  padding: 10px;
  overflow: auto;
}

.vnb__brand-image-wrapper__link__image {
  max-height: 125px;
  max-width: 200px;
}

.user-navigation {
  position: relative;
  display: inline-block;
  float: right;
  color: #808080;
  font-weight: 300;
}

.custom-section-content {
  text-align: right;
  color: red;
}

.super-toasty {
  height: 200px;
  width: 600px;
  top: 0;
  right: 2%;
}

.mighty-toasty {
  background-color: #1e7e34 !important;
}

.toasted-container.top-right {
  top: 0 !important;
  right: 2% !important;
}
</style>
